import { render } from "./StockNearExpiryReport.vue?vue&type=template&id=949af926&scoped=true&ts=true"
import script from "./StockNearExpiryReport.vue?vue&type=script&lang=ts"
export * from "./StockNearExpiryReport.vue?vue&type=script&lang=ts"

import "./StockNearExpiryReport.vue?vue&type=style&index=0&id=949af926&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949af926"]])

export default __exports__